import { ActionButton } from './druid/ActionButton/ActionButton';

/**
 * {@docCategory Button}
 */
export const CommandButton = ActionButton;
